import React, { FC } from 'react';
import classNames from 'classnames';
import { appConfigFactory } from 'src/shared/factories/appConfig.factory';
import { Platform } from 'src/environment';
import { noop } from 'src/shared/utilities/noop';
import { ToastMessageType } from './types';

const messageTypeClassMap: Record<ToastMessageType, string> = {
  [ToastMessageType.SUCCESS]: 's-toaster--primary',
  [ToastMessageType.WARNING]: 'u-background--warning',
  [ToastMessageType.ERROR]: 's-toaster--secondary',

  [ToastMessageType.SUBSCRIPTION_SUCCESS]: 's-toaster--success',
  [ToastMessageType.SUBSCRIPTION_WARNING]: 's-toaster--warning',
};
export interface ToastProps {
  type: ToastMessageType;
  onDismiss?: () => void;
  children: any;
  hideCloseButton?: boolean;
  stackable?: boolean;
}

export const ToastMessage: FC<ToastProps> = ({
  type,
  children,
  onDismiss = noop,
  hideCloseButton,
  stackable,
}: ToastProps) => {
  const appConfig = appConfigFactory();
  const content = <span>{children}</span>;

  const containerClassName = classNames('toast-message', {
    'toast-message--native': appConfig.platform !== Platform.WEB,
    'toast-message--stackable': stackable,
  });

  const innerClassName = classNames(
    's-toaster',
    'toast-message__inner',
    'u-flex',
    'u-text-primary--inverted',
    messageTypeClassMap[type],
  );

  return (
    <div className={containerClassName}>
      <div className={innerClassName}>
        {!hideCloseButton && (
          <button
            className="toast-message__icon s-btn s-btn-tertiary"
            onClick={onDismiss}
          >
            <span className="u-inline-block icon-x icon-sm" />
          </button>
        )}
        <div className="toast-message__content">{content}</div>
      </div>
    </div>
  );
};

ToastMessage.displayName = 'ToastMessage';
